var map = {
	"./q1.jpg": "ea0c",
	"./q2.jpg": "da53",
	"./qq1.jpg": "cc3b",
	"./qq10.jpg": "f3af",
	"./qq2.jpg": "94d5",
	"./qq3.jpg": "9aef",
	"./qq4.jpg": "c191",
	"./qq5.jpg": "1a59",
	"./qq6.jpg": "54ea",
	"./qq7.jpg": "8ae6",
	"./qq8.jpg": "cbb8",
	"./qq9.jpg": "9052"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5bbe";